/* istanbul ignore file */
// we don't test SVGs without arguments
import React from 'react'
import PropTypes from 'prop-types'

const PeopleIconTwo = ({ fill, title, ...rest }) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    {title && <title>{title}</title>}
    <path
      d="M6.5 0C7.36195 0 8.1886 0.34241 8.7981 0.951903C9.40759 1.5614 9.75 2.38805 9.75 3.25C9.75 4.11195 9.40759 4.9386 8.7981 5.5481C8.1886 6.15759 7.36195 6.5 6.5 6.5C5.63805 6.5 4.8114 6.15759 4.2019 5.5481C3.59241 4.9386 3.25 4.11195 3.25 3.25C3.25 2.38805 3.59241 1.5614 4.2019 0.951903C4.8114 0.34241 5.63805 0 6.5 0ZM6.5 8.125C10.0912 8.125 13 9.57938 13 11.375V13H0V11.375C0 9.57938 2.90875 8.125 6.5 8.125Z"
      fill={fill}
    />
  </svg>
)

PeopleIconTwo.defaultProps = {
  title: null,
  height: '13px',
  width: '13px',
  fill: '#73419F',
  viewBox: '0 0 13 13',
}

PeopleIconTwo.propTypes = {
  fill: PropTypes.string,
  height: PropTypes.string,
  title: PropTypes.string,
  viewBox: PropTypes.string,
  width: PropTypes.string,
}

export default PeopleIconTwo
